import {
  Component,
  Input,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { Router } from '@angular/router';
@Component({
  selector: 'app-carousel-dinamico',
  templateUrl: './carousel-dinamico.component.html',
  styleUrls: ['./carousel-dinamico.component.scss'],
})
export class CarouselDinamicoComponent implements AfterViewInit, OnDestroy {
  @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;

  @Input() lista: any;
  slideIndex: number = 1;
  timer = null;
  currentSlide: number = 0;
  slider: KeenSliderInstance = null;

  constructor(private router: Router) {}

  ngAfterViewInit() {
    this.slider = new KeenSlider(
      this.sliderRef.nativeElement,
      {
        loop: true,
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
        },
      },
      [
        (slider) => {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);

            if (slider.slides.length < 2) return;

            if (mouseOver) return;

            timeout = setTimeout(() => {
              slider.next();
            }, 7000);
          }
          slider.on('created', () => {
            slider.container.addEventListener('mouseover', () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener('mouseout', () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on('dragStarted', clearNextTimeout);
          slider.on('animationEnded', nextTimeout);
          slider.on('updated', nextTimeout);
        },
      ]
    );
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  public exibirSetas(exibir: boolean) {
    let setas = document.getElementsByClassName('setas');
    if (exibir) {
      for (let i = 0; i < setas.length; i++) {
        setas[i].className = setas[i].className.replace(' hide', '');
      }
    } else {
      for (let i = 0; i < setas.length; i++) {
        setas[i].className = setas[i].className + ' hide';
      }
    }
  }

  public abrirLink(url: string) {
    if (!url) return;

    if (url.includes('http')) {
      window.open(url, '_blank');
      return;
    }

    this.router.navigate([url]);
  }
}
